import moment from 'moment';

//──── Common ────────────────────────────────────────────────────────────────────────────

// Email regexp https://emailregex.com/
// eslint-disable-next-line no-useless-escape   
export const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/; 
export const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^\s]{8,}$/;

//──── National number ───────────────────────────────────────────────────────────────────
export const nationalRegex = /^(\d{11})$/;

export const isValidNationalNumber = nationalNumber => {
  let groupNumbers = nationalNumber.slice(0, 9);
  let year = parseInt(nationalNumber.slice(0, 2));
  let years = year > moment().format('YY') ? 1900 + year : 2000 + year;
  let controlNumber = parseInt(nationalNumber.slice(-2));
  let modulo = parseInt(years < 2000 ? groupNumbers : 2 + groupNumbers) % 97;
  return controlNumber === 97 - modulo;
};

export const isValidRequired = value => {
  if (!value) {
    return 'Sorry, this is mandatory';
  }
  return null;
};

//──── Login form validator ───────────────────────────────────────────────────────────

export const loginFormValidator = values => {
  const errors = {};

  if (!values.email) {
    errors.email = 'sorry_this_is_mandatory';
  } else if (!emailRegex.test(values.email)) {
    errors.email = 'invalid_email';
  }
  if (!values.password) {
    errors.password = 'sorry_this_is_mandatory';
  }

  return errors;
};
